import BasePaginationControls, { type PaginationControlsProps } from "@/components/feature/PaginationControls";

export default function PaginationControls(props: Omit<PaginationControlsProps, "variant">) {
  return <BasePaginationControls {...props} variant="admin" />;
}
